import cabinetStyle from "./MentorCabinet.module.css";
import EditIcon from "@mui/icons-material/Edit";
import {deepPurple} from "@mui/material/colors";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";

function EditComponent(props) {

    function renderTooltip(text) {
        return (<Tooltip id="button-tooltip">
            {text}
        </Tooltip>)
    }

    return(
        <OverlayTrigger
            placement="bottom"
            delay={{show: 50, hide: 400}}
            overlay={renderTooltip(props.toolTipText)}
        >
            <div className={cabinetStyle.controlsEdit} onClick={props.openOnClick}>
                <EditIcon sx={{ color: deepPurple[500]}}/>
            </div>

        </OverlayTrigger>
    )
}

export default EditComponent